import { CommonModule, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import {
  AlarmType,
  Client,
  GuidDictionaryItem,
} from '../../../../../../../api/api-reference';
import { FilterPanelComponent } from '../../filter-panel.component';

export interface IndividualAlarmsFilterOutput {
  selectedAssetTypes: string[];
  selectedAlarmTypes: AlarmType[];
}

@Component({
  selector: 'app-individual-alarms-filter',
  standalone: true,
  imports: [CommonModule, NgFor, TranslateModule, FilterPanelComponent],
  templateUrl: './individual-alarms-filter.component.html',
  styleUrl: './individual-alarms-filter.component.scss',
})
export class IndividualAlarmsFilterComponent implements OnInit {
  @Input() numberOfResults: number = 0;
  @Input() selectedAssetTypes: string[] = [];
  @Input() selectedAlarmTypes: AlarmType[] = [];

  @Output() applied = new EventEmitter<IndividualAlarmsFilterOutput>();

  assetTypes: GuidDictionaryItem[] = [];

  readonly alarmTypes = Object.values(AlarmType).slice(1);

  draftAssetTypes: string[] = [];
  draftAlarmTypes: AlarmType[] = [];

  get activeFilterCount(): number {
    return this.selectedAssetTypes.length + this.selectedAlarmTypes.length;
  }

  constructor(private client: Client, private toastr: ToastrService) {}

  ngOnInit(): void {
    this.reset();
    this.client.getAllAssetTypesForOptions(undefined).subscribe({
      next: (res) => (this.assetTypes = res ?? []),
      error: (err) => this.toastr.error(err),
    });
  }

  isIn<T>(list: T[], item: T): boolean {
    return list.includes(item);
  }

  toggle<T>(list: T[], item: T): T[] {
    return list.includes(item) ? list.filter((i) => i !== item) : [...list, item];
  }

  toggleGuid(list: string[], item: GuidDictionaryItem): string[] {
    const val = item.value!;
    return list.includes(val) ? list.filter((v) => v !== val) : [...list, val];
  }

  onApply(): void {
    this.applied.emit({
      selectedAssetTypes: this.draftAssetTypes,
      selectedAlarmTypes: this.draftAlarmTypes,
    });
  }

  onCancel(): void {
    this.reset();
  }

  private reset(): void {
    this.draftAssetTypes = [...this.selectedAssetTypes];
    this.draftAlarmTypes = [...this.selectedAlarmTypes];
  }
}
